import { useMsal } from '@azure/msal-react';
import { LogOut, ShieldAlert } from 'lucide-react';
import { logoutBackoffice } from './logout';
import { useBackofficePageTitle } from '@/lib/page-title';

export function ForbiddenPage() {
  const { instance } = useMsal();

  useBackofficePageTitle('Forbidden');

  return (
    <main className="min-h-[320px] bg-white p-6 md:p-8" aria-label="Backoffice main content">
      <section className="mx-auto max-w-3xl rounded-[28px] border border-red-100 bg-[linear-gradient(135deg,_rgba(254,242,242,1),_rgba(255,255,255,1))] p-8 shadow-soft md:p-10">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-700">
          <ShieldAlert className="h-6 w-6" aria-hidden="true" />
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.32em] text-red-700">
          Error 403
        </p>
        <h1 className="mt-3 font-inter-tight text-4xl font-semibold tracking-[-0.03em] text-neutral-900">
          You do not have access to Backoffice
        </h1>
        <p className="mt-4 max-w-2xl text-body text-neutral-600">
          Your account signed in successfully, but it is missing the required role for this
          application. Sign out to switch accounts or contact an administrator if access should be
          enabled.
        </p>

        <button
          type="button"
          className="focus-ring mt-8 inline-flex items-center justify-center gap-2 rounded-lg bg-neutral-900 px-5 py-3 text-small font-semibold text-white transition hover:bg-neutral-800"
          onClick={() => {
            void logoutBackoffice(instance);
          }}
        >
          <LogOut className="h-4 w-4" aria-hidden="true" />
          <span>Log out</span>
        </button>
      </section>
    </main>
  );
}
